import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createLogger } from 'redux-logger';
import { createBrowserHistory } from 'history';
import reducer from './reducer';

const history = createBrowserHistory();
const initialState = {};
// 当有dispatch 动作时 会有相应的log
// logger中间件
const logger = createLogger({
  level: 'info',
  logger: console,
  collapsed: true,
});
// 第二个用来关联redux 和 router 的中间件
const middlewares = [thunk, routerMiddleware(history), logger];
const store = createStore(
  connectRouter(history)(reducer),
  initialState,
  compose(applyMiddleware(...middlewares)),
);

export default store;
